import get from "lodash.get";
import { ActionContext } from "vuex";
import { IEmsAgency } from "@/TeamSelection/models/IEmsAgency";
import { TeamSelectionService } from "@/TeamSelection/services/TeamSelection.Service";
import { Storage as storage } from "@/App/services/LocalStorage";

function getDefaultState() {
  return {
    selectedTeam: JSON.parse(storage.getItem("selectedTeam") || "null"),
    autoLogout: JSON.parse(storage.getItem("autoLogout") || "false"),
    timeShiftEnds: JSON.parse(storage.getItem("timeShiftEnds") || "null"),
    complaints: [],
  };
}

const state = getDefaultState();

const getters = {
  selectedTeam: (state: any) => state.selectedTeam,
  autoLogout: (state: any) => state.autoLogout,
  timeShiftEnds: (state: any) => state.timeShiftEnds,
  complaints: (state: any) => state.complaints,
  complaintSet: (state: any) => (state.selectedTeam ? state.selectedTeam.complaintSet : " "),
  monitors: (state: any) => get(state, "selectedTeam.monitors", []),
  patientInfoForm: (state: any) => {
    if (!state.selectedTeam) {
      return;
    }
    return (state.selectedTeam.dynamicForms || []).find((form) => form.type === "patientInfo");
  },
};

export const actions = {
  selectTeam(context: ActionContext<any, any>, team: IEmsAgency) {
    context.commit("SELECT_TEAM", team);
    context.dispatch("loadComplaints", team.complaintSet);
  },
  async loadComplaints(context: ActionContext<any, any>, complaintSet: string) {
    const complaintSetObject = await TeamSelectionService.getComplaintSet(complaintSet);
    context.commit("SET_COMPLAINTS", complaintSetObject.complaints);
  },
  async loadHospitalStatuses(context: ActionContext<any, any>, id: string) {
    const statuses = await TeamSelectionService.getHospitalStatuses(id);
    const team = context.state.selectedTeam;
    team.hospitals.forEach((hospital) => {
      if (hospital.id === id) {
        hospital.activeStatuses = statuses;
      }
    });
    context.commit("SELECT_TEAM", team);
  },
  toggleAutoLogout(context: ActionContext<any, any>, autoLogout: boolean) {
    context.commit("TOGGLE_AUTO_LOGOUT", autoLogout);
  },
  setTimeShiftEnds(context: ActionContext<any, any>, timeShiftEnds: Object) {
    context.commit("SET_TIME_SHIFT_ENDS", timeShiftEnds);
  },
  resetState(context: ActionContext<any, any>) {
    context.commit("RESET_STATE");
  },
};

const mutations = {
  SELECT_TEAM(state: any, team: Object) {
    state.selectedTeam = team;
    storage.setItem("selectedTeam", JSON.stringify(state.selectedTeam));
  },
  SET_COMPLAINTS(state: any, complaints: Array<Object>) {
    state.complaints = complaints;
  },
  TOGGLE_AUTO_LOGOUT(state: any, autoLogout: boolean) {
    state.autoLogout = autoLogout;
    storage.setItem("autoLogout", JSON.stringify(state.autoLogout));
  },
  SET_TIME_SHIFT_ENDS(state: any, timeShiftEnds: Object) {
    state.timeShiftEnds = timeShiftEnds;
    storage.setItem("timeShiftEnds", JSON.stringify(state.timeShiftEnds));
  },
  RESET_STATE(state: any): void {
    storage.removeItem("selectedTeam");
    const initialState: any = getDefaultState();
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key];
    });
  },
};

const store: any = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default store;
